import React from 'react';
import { Box, Avatar, Typography, Chip, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';

const buildUserColumns = ({ t, openEditDrawer, openDeleteConfirm }) => [
  {
    field: 'username',
    headerName: t('Username'),
    flex: 1.2,
    minWidth: 180,
    renderCell: (params) => (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
        <Avatar sx={{ width: 30, height: 30, bgcolor: 'action.selected', color: 'text.secondary' }}>
          {params.value ? params.value.trim().charAt(0).toUpperCase() : '?'}
        </Avatar>
        <Typography variant="subtitle2" noWrap>{params.value}</Typography>
      </Box>
    ),
  },
  {
    field: 'name',
    headerName: t('Name'),
    flex: 1.2,
    minWidth: 180,
    renderCell: (params) => (
      <Typography variant="body2" noWrap>
        {[params.row.firstName, params.row.lastName].filter(Boolean).join(' ')}
      </Typography>
    ),
  },
  {
    field: 'email',
    headerName: t('Email'),
    flex: 1.6,
    minWidth: 220,
  },
  {
    field: 'role',
    headerName: t('Role'),
    flex: 0.8,
    minWidth: 100,
    renderCell: (params) => (
      <Chip
        label={params.value}
        size="small"
        variant={params.value === 'admin' ? 'filled' : 'outlined'}
        color={params.value === 'admin' ? 'primary' : 'default'}
        sx={{ textTransform: 'capitalize' }}
      />
    ),
  },
  {
    field: 'actions',
    headerName: '',
    width: 96,
    sortable: false,
    filterable: false,
    renderCell: (params) => (
      <Box sx={{ display: 'flex', gap: 0.5 }}>
        <Tooltip title={t('Edit')}>
          <IconButton size="small" onClick={() => openEditDrawer(params.row)} aria-label={t('Edit')}>
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip title={t('Remove user', { defaultValue: 'Remove user' })}>
          <IconButton size="small" color="error" onClick={() => openDeleteConfirm([params.row])} aria-label={t('Remove user', { defaultValue: 'Remove user' })}>
            <PersonRemoveIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
    ),
  },
];

export default buildUserColumns;
